import React from 'react';
import bse_icon from '../../assets/bse_icon.webp';
import amfi_icon from '../../assets/amfi_icon.webp';
import { HashLink as Link } from 'react-router-hash-link';
import { Container, Row, Col } from 'react-bootstrap';
import tarrakkiLogo from '../../assets//elevo/ELEVO.png';
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <section className='text-black footer text-lg-left mt-6 '>
      <Container>
        <Row>
          <Col lg='5' md='12' className='mb-4 mb-md-0'>
            <img
              src={tarrakkiLogo}
              alt='Tarrakki Towards Prosperity'
              className='logo'
            />
          </Col>
          <Col lg='2' md='6' className='mb-4 mb-md-0'>
            <p className='footerpara footerpara-heading'>Company</p>
            <p className='footerpara'>
              <Link to='/AboutUs' smooth className='hyperlink'>
                About Us
              </Link>
            </p>
            <p className='footerpara'>
              <Link to={'/whyelevo'} smooth className='hyperlink'>
                Why Elevo
              </Link>
            </p>
            <p className='footerpara'>
              <a href='https://www.tarrakki.com/news' className='hyperlink'>
                Press
              </a>
            </p>
            <p className='footerpara'>
              <Link to='/amc-brokerage-rates' smooth className='hyperlink'>
                AMC Brokerage Rates
              </Link>
            </p>
          </Col>
          <Col lg='2' md='6' className='mb-4 mb-md-0 text-lg-left'>
            <p className='footerpara footerpara-heading'>Support</p>
            <p className='footerpara'>
              <a href='mailto:support@elevo.money.com' className='hyperlink'>
                support@elevo.money
              </a>
            </p>
          </Col>
          <Col lg='3' md='6' className='mb-4 mb-md-0'>
            <p className='footerpara'>IIMA Ventures, IIMA New Campus, Vastrapur,</p>
            <p className='footerpara'>Ahmedabad, Gujarat - 380015</p>
          </Col>
        </Row>
      </Container>
      <Container className='mb-5 mt-4'>
        <Row>
          <Col lg='4' md='6' className='mb-4 mb-md-0'>
            <img src={bse_icon} alt='icon-1' className='bse-icon' />
          </Col>
          <Col lg='4' md='6' className='mb-4 mb-md-0'>
            <img src={amfi_icon} alt='icon-2' className='amfi-icon' />
          </Col>
          <Col lg='4' md='12' className='mb-4 mb-md-0'>
            <span className='icons'>
              <a
                href='https://www.facebook.com/elevo.money/'
                target='_blank'
                rel='noreferrer'
              >
                {' '}
                <FaFacebookF size={20} color='black' />
              </a>
            </span>
            <span className='icons'>
              <a
                href='https://instagram.com/elevo.money?utm_medium=copy_link'
                target='_blank'
                rel='noreferrer'
              >
                <FaInstagram size={20} color='black' />
              </a>
            </span>
            <span className='icons'>
              <a
                href='https://twitter.com/elevo_?s=21'
                target='_blank'
                rel='noreferrer'
              >
                <FaTwitter size={20} color='black' />
              </a>
            </span>
            <span className='icons'>
              <a
                href='https://www.linkedin.com/company/tarrakki/'
                target='_blank'
                rel='noreferrer'
              >
                <FaLinkedinIn size={20} color='black' />
              </a>
            </span>
            <span className='icons'>
              <a
                href='https://m.youtube.com/channel/UC4vQy-jvqZvrSgngpoFG-_g'
                target='_blank'
                rel='noreferrer'
              >
                <FaYoutube size={20} color='black' />
              </a>
            </span>
          </Col>
        </Row>
      </Container>
      <hr />
      <div className='disclosure container mt-4'>
        <p className='footerpara footerpara-heading'>
          AMFI Registered Mutual Fund Distributor
        </p>
        <p className='footerpara'>
          Elevo is an AMFI-Registered Mutual Fund Distributor via Plutonomic
          Savtech Private Limited with ARN (AMFI Registration Number):
          ARN-147985. Elevo is authorized to distribute mutual fund schemes
          in accordance with the AMFI Code of Conduct for Mutual Fund
          Distributors and applicable regulatory guidelines.
        </p>
        <p className='footerpara'>
          Mutual Fund Investments are subject to market risks, read all
          scheme related documents carefully. The past performance of a
          mutual fund scheme is not indicative of future performance and
          should not be considered as a basis for making an investment
          decision.
        </p>
      </div>
      <hr />
      <div className='copyright container mt-4 '>
        <span>
          <Link smooth to='/tos#tos' className='hyperlink'>
            Terms Of Service
          </Link>{' '}
          &
          <Link smooth to='/privacy#privacy' className='hyperlink'>
            {' '}
            Privacy Policy
          </Link>
        </span>
        <span style={{ float: 'right', marginBottom: '1.5rem' }}>
          {' '}
          &copy; Plutonomic Savtech Pvt Ltd. [CIN:U72900GJ2018PTC101542] All
          Rights Reserved
        </span>
      </div>
    </section>
  );
};

export default Footer;
